"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _fp = require("lodash/fp");
var _constants = require("@ahmdigital/constants");
var getProductTypeFromProductId = function(productId) {
    return (0, _fp.findKey)(function(products) {
        return (0, _fp.includes)(productId, (0, _fp.values)(products));
    }, _constants.PRODUCTS_BY_TYPE) || null;
};
var _default = getProductTypeFromProductId;
